import { theme } from "@op-str/op-component-library"
import React from "react"
import styled, { css } from "styled-components"
import { ButterCmsErrorBoundary } from "./ButterCmsErrorBoundary"
import { HorizontalLine } from "./HorizontalLine"

export type SubtitleAndTitleProps = {
  subtitle?: string
  title?: string
  bgImage?: string
}

const COMPONENT_NAME = "SubtitleAndTitle"

export const SubtitleAndTitle = (props: SubtitleAndTitleProps) => {
  const { subtitle, title, bgImage } = props

  return (
    <ButterCmsErrorBoundary componentName={COMPONENT_NAME}>
      <>
        <ExtraLargeVerticalSpace />
        <NarrowPageContent $bgImage={bgImage}>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          {title && <Title>{title}</Title>}
          <ExtraLargeVerticalSpace />
        </NarrowPageContent>
        <HorizontalLine />
      </>
    </ButterCmsErrorBoundary>
  )
}

const ExtraLargeVerticalSpace = styled.div`
  min-height: ${theme.spacing.xxl};
`

const NarrowPageContent = styled.div<{ $bgImage?: string }>`
  position: relative;
  margin: 0 auto;
  width: ${theme.ui.content.widthNarrow};

  ${(props) => css`
    background-image: url(${props.$bgImage});
    background-size: 148px;
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: bottom;
  `}
`

const Subtitle = styled.div`
  width: 565px;
  font-size: ${theme.fontSize.xl};
  font-weight: bold;
  padding-bottom: 0;
`

const Title = styled.div`
  width: 565px;
  font-size: 48px;
  line-height: 56px;
  font-weight: bold;
`
